import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from '@environments/environment';
import { enableProdMode } from '@angular/core';
import { Amplify } from 'aws-amplify';
import awsconfig from '@core/constants/aws-config';

Amplify.configure(awsconfig);
if (environment.production)
  enableProdMode()

platformBrowser().bootstrapModule(AppModule)
  .catch(err => console.error(err));